import qs from 'qs'
import React, { useEffect, useState } from 'react'
import { CollectionDisplayList } from '../collection/CollectionDisplayList'
import MainButton from '../common/util/input/MainButton'
import { setQueryStringWithoutPageReloadPush } from '../helpers/FormatLinks'
import { SearchBar } from '../searchbar/SearchBar'
import { VerifiedSelector } from '../verifiedselector/VerifiedSelector'
import { Tabs, Tab } from '@nextui-org/react'

import { useTranslation } from 'react-i18next'
import { useCollectionType } from '../../hooks'

export const COLLECTION_TYPE_ALL = 1
export const COLLECTION_TYPE_OTHER = 0
export const COLLECTION_TYPE_GAMES = 2
export const COLLECTION_TYPE_PFP = 3
export const COLLECTION_TYPE_COLLECTIBLES = 4
export const COLLECTION_TYPE_ART = 5

function CollectionOverview(props) {
    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    const [searchTerm, setSearchTerm] = useState(
        values['search'] ? values['search'] : '',
    )

    const search = searchTerm ? searchTerm : '*'

    const [term, setTerm] = useState(null)

    const tagId = values && values['tag_id'] ? values['tag_id'] : null
    const [limit, setLimit] = useState(100)

    const onSubmit = (e) => {
        e.preventDefault()
        setQueryStringWithoutPageReloadPush(qs.stringify({ search: term }))
        setSearchTerm(term)
    }

    const applyTerm = (term) => {
        setSearchTerm(term)
        let values = qs.parse(
            window.location.search.substring(1, window.location.search.length),
        )
        if (term) {
            values['search'] = term
        } else {
            delete values['search']
        }
        setQueryStringWithoutPageReloadPush(qs.stringify(values))
    }

    const handleTermChange = (e) => {
        setTerm(e.target.value)
    }

    const [subPage, setSubPage] = useState('trending')

    const [searchVerified, setSearchVerified] = useState(
        typeof window !== 'undefined' && values['verified']
            ? values['verified']
            : props['verified']
            ? props['verified']
            : 'verified',
    )

    const { loading: isLoadingTrending, collections: trendingCollections } =
        useCollectionType(
            search,
            tagId,
            !subPage || subPage === 'trending',
            COLLECTION_TYPE_ALL,
            limit,
            searchVerified,
            true,
        )

    const { loading: isLoadingAll, collections: allCollections } =
        useCollectionType(
            search,
            tagId,
            !subPage || subPage === 'all',
            COLLECTION_TYPE_ALL,
            limit,
            searchVerified,
        )

    const { loading: isLoadingOther, collections: otherCollections } =
        useCollectionType(
            search,
            tagId,
            !subPage || subPage === 'other',
            COLLECTION_TYPE_OTHER,
            limit,
            searchVerified,
        )

    const { loading: isLoadingArt, collections: artCollections } =
        useCollectionType(
            search,
            tagId,
            !subPage || subPage === 'art',
            COLLECTION_TYPE_ART,
            limit,
            searchVerified,
        )

    const {
        loading: isLoadingCollectibles,
        collections: collectiblesCollections,
    } = useCollectionType(
        search,
        tagId,
        !subPage || subPage === 'collectibles',
        COLLECTION_TYPE_COLLECTIBLES,
        limit,
        searchVerified,
    )

    const { loading: isLoadingGames, collections: gameCollections } =
        useCollectionType(
            search,
            tagId,
            !subPage || subPage === 'games',
            COLLECTION_TYPE_GAMES,
            limit,
            searchVerified,
        )

    const { loading: isLoadingProfile, collections: profileCollections } =
        useCollectionType(
            search,
            tagId,
            !subPage || subPage === 'pfp',
            COLLECTION_TYPE_PFP,
            limit,
            searchVerified,
        )

    useEffect(() => {}, [search, limit])

    const { t } = useTranslation('common')

    const trendingElement = {
        title: 'landing.trending',
        key: 'trending',
        isLoading: isLoadingTrending,
        collections: trendingCollections,
        type: COLLECTION_TYPE_ALL,
    }

    const allElement = {
        title: 'landing.all',
        key: 'all',
        isLoading: isLoadingAll,
        collections: allCollections,
        type: COLLECTION_TYPE_ALL,
    }

    const otherElement = {
        title: 'landing.other',
        key: 'other',
        isLoading: isLoadingOther,
        collections: otherCollections,
        type: COLLECTION_TYPE_ALL,
    }

    const gameElement = {
        title: 'landing.games',
        key: 'games',
        isLoading: isLoadingGames,
        collections: gameCollections,
        type: COLLECTION_TYPE_GAMES,
    }

    const artElement = {
        title: 'landing.art',
        key: 'art',
        isLoading: isLoadingArt,
        collections: artCollections,
        type: COLLECTION_TYPE_PFP,
    }

    const oneOfOneElement = {
        title: 'landing.pfp',
        key: 'pfp',
        isLoading: isLoadingProfile,
        collections: profileCollections,
        type: COLLECTION_TYPE_COLLECTIBLES,
    }

    const collectElement = {
        title: 'landing.collectibles',
        key: 'collectibles',
        isLoading: isLoadingCollectibles,
        collections: collectiblesCollections,
        type: COLLECTION_TYPE_ART,
    }

    const categories = [
        trendingElement,
        allElement,
        gameElement,
        collectElement,
        artElement,
        oneOfOneElement,
        otherElement,
    ]

    const loadMore = () => {
        setLimit(limit + 100)
    }

    const category = subPage
        ? categories.filter((category) => category.key === subPage)[0]
        : ''

    return (
        <div className="px-4">
            <div className="overflow-x-auto">
                <Tabs
                    classNames={{
                        tab: 'md:px-6 px-4 md:py-6 py-4',
                        tabContent: 'md:text-base text-sm',
                    }}
                    key="collections"
                    variant="light"
                    aria-label="collections tabs"
                    selectedKey={subPage}
                    onSelectionChange={(key) => setSubPage(key)}
                >
                    {categories.map((category) => (
                        <Tab key={category.key} title={t(category.title)} />
                    ))}
                </Tabs>
            </div>
            <div className={'flex justify-between items-center my-6 flex-row'}>
                <SearchBar
                    onSubmit={onSubmit}
                    placeHolder={'Collection'}
                    onChange={handleTermChange}
                    value={term ? term : ''}
                    onClickSearch={() => applyTerm(term)}
                />
                <div className="my-auto ml-3">
                    <VerifiedSelector
                        searchVerified={searchVerified}
                        setSearchVerified={setSearchVerified}
                        searchSearch={'collections'}
                    />
                </div>
            </div>

            {(subPage || subPage === 0) && (
                <div>
                    <CollectionDisplayList category={category} />
                    <div className={'flex justify-center'}>
                        <MainButton
                            className={'mx-auto mt-8'}
                            onClick={loadMore}
                            disabled={category.isLoading}
                        >
                            Load More
                        </MainButton>
                    </div>
                </div>
            )}
        </div>
    )
}

export default CollectionOverview
